import SingleTranslateSelect from '@op/components/FilterBoxCommon/filters/languages/singleLauage';
import React, { useContext, useMemo, useRef } from 'react';
import BubbleCommon, {
  summaryDisabledTips,
  summaryNotFoundDisabledTips,
  topicTrackTopicSettingTips,
} from '@op/components/BubbleCommon';
import { Button, Checkbox, Input, Justify } from 'tea-component';
import { scrollToAnchorPoint } from '@op/utils';
import NewRegionSelect from '@home/components/NewRegionSelect';
import { getLocale, useIntl } from 'umi';
import { FilterContext } from '../../context';
import {
  useQuickPickOptions,
  useTopicSelectConfig,
} from '../../hooks/useTopicConfig';
import { topicLocale } from '@op/components/FilterCommon/constants/topic';
import useDefaultTwoLevelFilter from '@op/components/FilterCommon/hooks/useDefaultTwoLevelFilter';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export function TopicChartFilter({
  setLanguageType,
  ...props
}: {
  setLanguageType: any;
  topicList: Array<any>;
  topic2Select: Array<string>;
  setTopic2Select: any;
}) {
  return (
    <div className="topic-performance-filter-wrapper">
      <SingleTranslateSelect
        key="language"
        defaultValue="origin"
        onChange={(_key: string, value: any) => {
          buriedBtnPoint('STO_Trans');
          setLanguageType(value);
        }}
      ></SingleTranslateSelect>
      <TopicQuickSelect {...props}></TopicQuickSelect>
    </div>
  );
}

export default function TopicTableFilter({
  setLanguageType,
  topN,
  setTopN,
  selectTopN,
  setSelectTopN,
}: {
  topN: number;
  setTopN: (value: number) => void;
  selectTopN: boolean;
  setSelectTopN: (value: boolean) => void;
  setLanguageType: any;
}) {
  const { formatMessage } = useIntl();

  const topNRef = useRef<string | number>(topN);

  function inputChange(value: string) {
    const num = Number(value);
    if (isNaN(num) || num < 1) return;
    setTopN(num);
  }

  return (
    <div className="topic-performance-filter-wrapper">
      <Justify
        left={
          <SingleTranslateSelect
            key="language"
            defaultValue="origin"
            onChange={(_key: string, value: any) => {
              buriedBtnPoint('STO_Trans');
              setLanguageType(value);
            }}
          ></SingleTranslateSelect>
        }
        right={
          <Checkbox
            value={selectTopN}
            onChange={(value, e) => {
              setSelectTopN(value);
              e.event.stopPropagation();
            }}
          >
            {formatMessage(
              { id: 'Show top {number} mentions topics only' },
              {
                number: (
                  <Input
                    defaultValue={String(topN)}
                    onBlur={() => {
                      inputChange(topNRef.current as string);
                    }}
                    onChange={(value) => (topNRef.current = value)}
                    onPressEnter={inputChange}
                    style={{ width: 50, margin: '0 5px' }}
                  ></Input>
                ),
              },
            )}
          </Checkbox>
        }
      ></Justify>
    </div>
  );
}

function TopicQuickSelect({
  topicList,
  topic2Select,
  setTopic2Select,
}: {
  topicList: Array<any>;
  topic2Select: Array<string>;
  setTopic2Select: any;
}) {
  const {
    transTopic,
    gameInfo,
    topicTwoLevel,
    topicOneLevel,
    topicTree,
    topicOptions,
  } = useContext(FilterContext);

  const activeTopics = useMemo(() => {
    return (topicList || []).map((item: any) =>
      item.topic?.toLocaleLowerCase(),
    );
  }, [topicList]);

  const { userQuickPickSelect, setUserTopicConfig, settingLoading } =
    useTopicSelectConfig({ gameInfo });

  const quickPickSelect = useQuickPickOptions({
    topicOneLevel,
    topicTwoLevel,
    userQuickPickSelect,
    tableTopicList: topicList,
    topicTree,
    setTopic2Select,
  });

  const { selectValue } = useDefaultTwoLevelFilter({
    originalOptions: topicOptions,
    onlySecondLevelValue: false,
    filterValue: topic2Select,
    beginWatch: true,
    dealwithDefaultValue: (value: any) => {
      let topic = Array.isArray(value) ? value : [];
      return { value: topic, type: 'market' };
    },
  });

  return (
    <div className="topic-select-box">
      {quickPickSelect.map(({ value: topic, isNotHaveDisable }) => {
        const value = topic?.toLocaleLowerCase();
        const disabled = !activeTopics.includes(value) || isNotHaveDisable;
        let tips = undefined;
        if (disabled) {
          tips = isNotHaveDisable
            ? summaryNotFoundDisabledTips
            : summaryDisabledTips;
        }

        return (
          <BubbleCommon
            key={value}
            placement="top"
            showIcon={false}
            tipsMap={tips}
            dark
          >
            <Button
              key={value}
              className={`topic-item  ${disabled ? 'disable' : ''}`}
              type="weak"
              onClick={() => {
                buriedBtnPoint('STO_topicPosition', value);
                scrollToAnchorPoint(value, 'center');
              }}
            >
              {transTopic(value, 'L1')}
            </Button>
          </BubbleCommon>
        );
      })}
      <BubbleCommon
        placement="top"
        showIcon={false}
        tipsMap={topicTrackTopicSettingTips}
      >
        <NewRegionSelect
          className="dbo-region-select"
          value={selectValue}
          options={topicOptions}
          locale={getLocale()}
          language={topicLocale}
          closeOnScroll={true}
          onCloseReginSelect={(tags: any) => {
            let { markets } = tags;
            // 查找一级分类，因为选中部分二级分类并不会返回该一级分类
            let oneLevel: Array<any> = [];
            topicOptions.forEach((item: any) => {
              const flag = item.children.some((v: any) =>
                markets.includes(v.value),
              );
              if (flag) {
                oneLevel.push(item.value);
              }
            });
            buriedBtnPoint('STO_topicPositionSetting');
            setUserTopicConfig(oneLevel, markets);
          }}
          shortcutOptions={undefined}
          realRegionsList={[]}
        />
      </BubbleCommon>
    </div>
  );
}
